import React 								from 'react';
import BLComponent							from '../../core/_BLComponent.jsx';
import Modal 								from '../../modals/_DynamicModal.jsx';

import inventoryFileProc					from '../controller/inventoryFileProcess.jsx';

import ImportXMLModalBody					from './_ImportXMLModalBody.jsx';

export default class ImportXMLModal extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 

		this.state	= 	{
			curStep: 0
		,	fileOption: -1
		,	importType:-1
		,	fileImported: false
		,	uploadError: false
		,	uploadErrorMsg: ""
		,	importingFileName: ""
		,	importResult: {}
		,	showError:false
		,	progressUploading:0
		,	fileSizeError:false
		,	xmlFormatError:false
		,	totalUploadQty:10000
		,	allowEmptyUpload:false
		};
	}

	render()
	{
		return (
			<div>
				{this.renderModal()}
			</div>
		)
	}

	getModalPageType(curStep, fileOption)
	{
		if (curStep == 0) return 0;
		else if (curStep > 0 ) 
		{
			if (fileOption == 0) 
				return curStep;
			else 
				return curStep+1;
		}
		return 0;
	}

	getModalTitle(itemType) {
		const modalTitle = [
			"Import list to My " + itemType + "s"
		,	"Custom file formatting"
		,	"Upload collection file"
		,	"Upload complete"
		]

		const curStep = this.state.curStep;
		const fileOption = this.state.fileOption;

		if (curStep == 0) return modalTitle[0];
		else if (curStep == 1)
		{
			if (fileOption == 0) 
				return modalTitle[1];
			else
				return modalTitle[2];
		}
		else if (curStep == 2)
		{
			if (fileOption == 0)
				return modalTitle[2];
			else
				return modalTitle[2];
		}
		else if (curStep == 3)
		{
			if (fileOption == 0)
				return modalTitle[2];
			else
				return modalTitle[2];
		}
		else if (curStep == 4)
		{
			if (fileOption == 0)
				return modalTitle[2];
			else
			{
				if (this.state.importResult != null)
				{
					if ( (this.state.importResult.totalItems == 0) && (this.state.importResult.uploadedItems == 0) && (this.state.totalUploadQty > 0))
					{
						return modalTitle[2];
					}
				}
				return modalTitle[3];
			}
		}
		else if (curStep == 5)
		{
			if (this.state.importResult != null)
			{
				if ( (this.state.importResult.totalItems == 0) && (this.state.importResult.uploadedItems == 0) && (this.state.totalUploadQty > 0) )
				{
					return modalTitle[2];
				}
			}
			return modalTitle[3];
		}
		return "";
	}

	renderModal() {
		const itemTypeList = {P:"Part", B:"Book", M:"Minifigure", C:"Catalog", S:"Set", G:"Gear"};
		const itemType = this.props.data.itemType;
		
		const title = (this.state.showError)?"Inventory Errors":this.getModalTitle(itemTypeList[itemType]);
		const importResult = this.state.importResult;

		const importXMLModalBody = () => {
			return (
				<ImportXMLModalBody 
					data={{
						itemType:itemType
					,	curStep: 			this.state.curStep
					,	fileOption: 		this.state.fileOption 
					,	fileImported: 		this.state.fileImported
					,	importType: 		this.state.importType
					,	uploadError: 		this.state.uploadError
					,	uploadErrorMsg: 	this.state.uploadErrorMsg
					,	importingFileName: 	this.state.importingFileName
					,	importResult: 		importResult
					,	showError: 			this.state.showError
					,	progressUploading: 	this.state.progressUploading
					,	fileSizeError: 		this.state.fileSizeError
					,	xmlFormatError:		this.state.xmlFormatError
					,	totalUploadQty:		this.state.totalUploadQty
					,	allowEmptyUpload:	this.state.allowEmptyUpload
					}} 
					func={{
						selectFileOption: (fileOption)=>this.selectFileOption(fileOption)
					,	stepForward: ()=>this.stepForward()
					,	setImportType: (type)=>this.setImportType(type)
					,	setFile: (files,cb)=>this.setFile(files,cb)
					,	startImporting: () => this.startImporting()	
					,	showError: ()=> this.showError()
					,	toggleModal: ()=> this.toggleModal()
					}} />
			)
		}
		const modalPageType = this.getModalPageType(this.state.curStep, this.state.fileOption);
		const buttons = this.getButtonList(modalPageType);
		const showIcon = (this.state.showError)?false:((modalPageType > 0) && (modalPageType < 4))?true:(modalPageType == 0)?false:(title != "Upload complete")?true:false;
		const iconClass =  "fa-solid fa-arrow-left";

		const modalOption = {
			title: { name: title, showIcon: showIcon, iconClass:iconClass, showClose: true, display: true, clickable: false, clickIcon:()=>{this.stepBack()}, callback:()=>{return null} }
		,	showCloseButton: true
		,	closeOnEscape: true
		,	modalSize: "s" /* s m l */
		,	ModalBody: importXMLModalBody
		,	ModalFooter: {
				buttons: {
					direction: "row"
				,	list: buttons
				}
			,	dontshowagain: { msg:"Don't show again", display: false, func:()=>{return null}}
			,	footerClass: "personal-inventory__dmodal-footer"
			}
		,	closeFunc: ()=>this.toggleModal()

		}

		return (
			<Modal data={ modalOption }/>
		)
	}

	getButtonList(modalPageType)
	{
		
		let buttons = [];
		switch(modalPageType)
		{
			case 1: buttons[0] = { name: "Choose file", class: "btn btn--cta l-full-width", disabled: false, func:()=>{this.stepForward()}}
					break;
			case 2: buttons[0] = { name: "Submit", class: "btn btn--cta l-full-width", disabled: (!this.state.fileImported || this.state.fileSizeError )?true:false, func:()=>{this.stepForward()}}
					break;
			case 3: 
					if ( (this.state.totalUploadQty > 0) || (this.state.allowEmptyUpload == true) )
					{
						buttons[0] = { name: "Submit", class: "btn btn--cta l-full-width", disabled: ( ((this.state.importType == 1) || (this.state.importType == 2)) && (!this.state.fileSizeError) )?false:true, func:()=>{this.startImporting()}}
					}
					else
					{
						buttons[0] = { name: "Cancel", class: "btn btn--white l-full-width l-border", func:()=>{this.stepBack()}}
						buttons[1] = { name: "Continue", class: "btn btn--cta l-full-width", func:()=>{this.allowEmptyUpload(true)}}
					}
					break;
			case 4: buttons[0] = { name: "Uploading", class: "btn btn--cta l-full-width", disabled: true, func:()=>{return null}}
					break;
			case 5: 
					const {totalItems, uploadedItems, resultCode, errorList} = this.state.importResult;

					if (this.state.showError || this.state.uploadError)
					{
						buttons[0] = { name: "Done", class: "btn btn--cta l-full-width", disabled: false, func:()=>{this.toggleModal()}}
					}
					else if ( (totalItems == 0) && (uploadedItems == 0) )
					{
						buttons[0] = { name: "Done", class: "btn btn--cta l-full-width", disabled: false, func:()=>{this.toggleModal()}}
					}
					else
					{
						if ( (errorList == null) || (errorList.length == 0) )
							buttons[0] = { name: "Done", class: "btn btn--cta l-full-width", disabled: false, func:()=>{this.toggleModal()}}
						else if ( (errorList != null) && (errorList.length > 0) )
							buttons[0] = { name: "See errors", class: "btn btn--cta l-full-width", disabled: false, func:()=>{this.showError()}}
					}
					
					break;

		}
		return buttons;
	}

	allowEmptyUpload(bAllow) {
		this.setState({ allowEmptyUpload:bAllow});
	}

	stepBack()
	{
		const fileOption = this.state.fileOption;
		let curStep = this.state.curStep - 1;

		if ( (fileOption == 0) && (curStep == 4) ) curStep--; 
		if ( (fileOption == 1) && (curStep == 3) ) curStep--; 
		this.setState({curStep:curStep});

	}

	stepForward() 
	{
		const curStep = this.state.curStep + 1;
		this.setState({curStep:curStep});
	}

	selectFileOption(fileOption)
	{
		const curStep = this.state.curStep+1;
		this.setState({curStep:curStep, fileOption: fileOption});
	}

	toggleModal() {
		this.props.func.closeImportXMLModal();
	}

	setFile(files, cb) {
		const importingFileName = files[0].name;
		const ext = importingFileName.match(/\.[0-9a-z]+$/i)[0];
		const isXML = (ext == ".xml")?true:false;
		const isCSV = (ext == ".csv")?true:false;
		let invComponent;

		if (isXML)
		{
			invComponent = inventoryFileProc.blInventoryXML;
		}
		if (isCSV)
		{
			invComponent = inventoryFileProc.blInventoryCSV;
		}
		
		invComponent.loadFile(files[0], (type)=>this.callbackUploadInvFiles(type));
		
		if (files[0].size > 5120000) //5MB size limit
		{
			this.setState({fileSizeError:true, allowEmptyUpload:false});
		}
		else
		{
			this.setState({fileSizeError:false, files:files, cb:cb, importingFileName: importingFileName, fileImported: true, allowEmptyUpload:false, curStep: this.state.curStep+1});
		}
	}

	callbackUploadInvFiles(type) {
		const component = (type == "xml")?inventoryFileProc.blInventoryXML:inventoryFileProc.blInventoryCSV;
		const XMLStatus = component.getStatus();
		const totalUploadQty = component.getTotalItemQty();
		
		if (XMLStatus != 2)
		{
			this.setState({xmlFormatError: false, totalUploadQty: totalUploadQty, importType: -1});
		}
		else
		{
			this.setState({xmlFormatError: true, totalUploadQty: 0});
		}
	}

	setImportType(type) {
		
		this.setState({importType: type});
	}

	startImporting() {
		
		this.stepForward();

		const files = this.state.files;
		const cb = this.state.cb;

		if (files && files.length > 0) {
			blapp.fileuploader.uploadUserTemp(
				[files[0]]
				, (tempFiles) => this.onImportXMLFile(tempFiles, cb)
				, (code)=>this.callbackError(code)
				, (prog)=>this.callbackProgress(prog) 
			);
		}
		
	}

	callbackError(code) {
		
	}

	callbackProgress(prog) {
		this.setState({progressUploading:prog});
	}

	triggerAlert(msg) {
		this.setState({uploadError:true, uploadErrorMsg:msg});
	}

	showError() {
		this.setState({showError:true});
	}

	saveUploadRes(res) {
		this.setState({importResult:res}, this.stepForward());
	}

	onImportXMLFile(tempFiles, cb) {

		const fileType = "XML";
		const importOption = ( ( this.state.fileOption == 0 ) || ( this.state.fileOption == 1 ) )?0:( this.state.fileOption == 2 )?1:( this.state.fileOption == 3 )?2:0;
		const itemType = this.props.data.itemType;
		const importType = this.state.importType;
		
		blapp.models.fetch(
			"_personalInventoryImportRes"
			, {
				controller: "user.BLCUserMyPersonalInventory"
				, method: "importInventory"
				, params: [importOption, itemType, importType, tempFiles[0]]
				, refresh: true
			}
		).then(
			(res) => {
				this.saveUploadRes(res);
			}
		).catch(
			(err) => {
				const errMSg = "Error uploading model: " + err;
				this.setState({uploadError:true, uploadErrorMsg:errMSg}, this.stepForward());
			}
		)

	}
};

